"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcnVoucherDto = void 0;
class AcnVoucherDto {
    constructor(params) {
        this.dealerId = "";
        this.cardholderId = "";
        this.firstName = "";
        this.lastName = "";
        this.email = "";
        this.phone = "";
        this.cardCode = "";
        this.expirationDate = "";
        this.vin = "";
        this.stations = [];
        this.hasBeenRedeemed = false;
        this.activityLog = [
            {
                "date": "",
                "description": ""
            }
        ];
        this.isDeleted = false;
        if (!params) {
            return;
        }
        this.id = params.id;
        this.dealerId = params.dealerId;
        this.cardholderId = params.cardholderId;
        this.firstName = params.firstName;
        this.lastName = params.lastName;
        this.email = params.email;
        this.phone = params.phone;
        this.cardCode = params.cardCode;
        this.expirationDate = params.expirationDate;
        this.vin = params.vin;
        this.stations = params.stations;
        this.hasBeenRedeemed = params.hasBeenRedeemed;
        this.activityLog = params.activityLog;
        this.isDeleted = params.isDeleted;
    }
}
exports.AcnVoucherDto = AcnVoucherDto;
//# sourceMappingURL=AcnVoucherDto.js.map